/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountWelcomeTileViewProps } from '@msdyn365-commerce-modules/account-management';

const AccountWelcomeTileView: React.FC<IAccountWelcomeTileViewProps> = props => {
    const { AccountWelcomeTile, heading } = props;

    return (
        <Module {...AccountWelcomeTile}>
            {heading}
            {props.data.accountInformation?.result?.AccountNumber && (
                <span className='ms-account-welcome-tile__heading'>
                   {' '} - {props.data.accountInformation.result.AccountNumber}
                </span>
            )}
        </Module>
    );
    
};

export default AccountWelcomeTileView;
